export const deserializeCampaign = campaign => ({
  uuid: campaign.campaign_uuid,
  name: campaign.name,
  redirectionUrl: campaign.redirection_url,
  creativeDesktop: {
    url: campaign.creative_desktop ? campaign.creative_desktop.url : '',
    width: campaign.creative_desktop ? campaign.creative_desktop.width : 0,
    height: campaign.creative_desktop ? campaign.creative_desktop.height : 0,
  },
  creativeMobile: {
    url: campaign.creative_mobile ? campaign.creative_mobile.url : '',
    width: campaign.creative_mobile ? campaign.creative_mobile.width : 0,
    height: campaign.creative_mobile ? campaign.creative_mobile.height : 0,
  },
});

export default deserializeCampaign;
